import styled from 'styled-components';
import {Box} from "@mui/material";

export const BlueDot = styled(Box)`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #3B82F6;
    margin-top: 6px;
    flex-shrink: 0;
`;